import { render, staticRenderFns } from "./vLoginPostulante.vue?vue&type=template&id=0a18a49e&scoped=true&"
import script from "./vLoginPostulante.vue?vue&type=script&lang=js&"
export * from "./vLoginPostulante.vue?vue&type=script&lang=js&"
import style0 from "./vLoginPostulante.vue?vue&type=style&index=0&id=0a18a49e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a18a49e",
  null
  
)

export default component.exports